var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStiahnut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "transport",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.14,20.15a.57.57,0,0,0,.16.11.65.65,0,0,0,.19,0,.58.58,0,0,0,.19,0,.5.5,0,0,0,.17-.11l5-5a.5.5,0,0,0-.71-.71L12,18.59V.8a.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5V18.59L6.85,14.44a.51.51,0,0,0-.71,0,.5.5,0,0,0,0,.71Z",
    transform: "translate(0.01 -0.3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.49,17.3a.5.5,0,0,0-.5.5v5a.51.51,0,0,1-.5.5h-20A.5.5,0,0,1,1,22.8v-5a.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5v5a1.5,1.5,0,0,0,1.48,1.5h20A1.5,1.5,0,0,0,23,22.8v-5A.5.5,0,0,0,22.49,17.3Z",
    transform: "translate(0.01 -0.3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStiahnut);
export default __webpack_public_path__ + "static/media/Stiahnut.a6275f4283fade3d94f46041f02e7568.svg";
export { ForwardRef as ReactComponent };